export default __webpack_public_path__ + "static/ramengo-67acbb41568267785176de5e219fe251.png";